module.exports = __webpack_public_path__ + "detective.150aca16a52be4ae43352c3441ab6b41.png";